import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const INFO_SUBDOMAIN = process.env.REACT_APP_SUBDOMAIN || "";

const isInfoSection = window.location.host.startsWith(INFO_SUBDOMAIN);

const FloatingRoleSwitcher = () => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);

  // Docelowy host po przełączeniu
  let targetHost;
  if (isInfoSection) {
    targetHost = window.location.host.replace(INFO_SUBDOMAIN, "");
  } else {
    targetHost = `${INFO_SUBDOMAIN}${window.location.host}`;
  }

  const handleSwitch = () => {
    window.location.href = `${window.location.protocol}//${targetHost}/`;
  };

  return (
    <div 
      onClick={handleSwitch}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'fixed',
        right: hovered ? '0' : '-5px',
        top: '250px',
        transform: 'translateY(-50%)',
        backgroundColor: 'rgba(242, 244, 247, 0.7)',
        color: '#172f73',
        padding: '16px 8px',
        borderRadius: '8px 0 0 8px',
        border: '2px solid #172f73',
        cursor: 'pointer',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        transition: 'all 0.3s ease',
        zIndex: 500,
        writingMode: 'vertical-rl',
        textOrientation: 'mixed',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        fontWeight: '500',
        whiteSpace: 'nowrap',
        backdropFilter: 'blur(10px)',
        fontWeight: '500',
      }}
    >
      <ArrowRight size={18} style={{ flexShrink: 0, transform: 'rotate(90deg)' }} />
      <span>
        {isInfoSection ? t("redirect.switchToClient") : t("redirect.switchToInvestor")}
      </span>
    </div>
  );
};

export default FloatingRoleSwitcher;
